const KitCatImg = (props) => {
    return (
        <li>
            <img src={props.url} alt="a wonderful cat" />
        </li>
    )
}
export default KitCatImg;